/**
 * Generates a progression of numbers that ends with upTo and starts with the smallest number that is larger than after.
 * @param after Lower limit (exclusive; never part of result)
 * @param upTo Upper limit (inclusive; result with either be an empty array or contain this number)
 * @param step Distance between each two numbers in progression
 */
export function numbersAfterAndUpToIncluding(after: number, upTo: number, step: number): number[] {
    const integers = Array.from(
        {length: Math.ceil((upTo - after) / step)},
        (_, i) => upTo - (i * step)
    );
    integers.reverse();
    return integers;
}

type TickValue = { value: number };

export function buildTicksForTimeWindow(minMs: number, maxMs: number): TickValue[] {
    const MAX_TICKS_PER_WINDOW = 40;
    const SECOND_INTERVALS = [
        10 * 1000,         // 10 seconds
        20 * 1000,         // 20 seconds
        60 * 1000,         // 1  minute
        5 * 60 * 1000,     // 5  minutes
        10 * 60 * 1000,    // 10 minutes
        20 * 60 * 1000,    // 20 minutes
        60 * 60 * 1000     // 1 hour
    ];
    // find the first interval that fits at most X times (most precise first)
    const interval = SECOND_INTERVALS.find(eInterval => (maxMs - minMs) / eInterval <= MAX_TICKS_PER_WINDOW);

    // now find the last timestamp between min and max that satisfies the found interval
    const lastTimestampMs = interval * Math.floor(maxMs / interval);

    // and generate progression from it down to min with the found interval
    const timestamps = numbersAfterAndUpToIncluding(minMs, lastTimestampMs, interval);

    // generate array of TickValues and return it
    return timestamps.map((eTimestamp) => {
        return {
            value: eTimestamp
        }
    });
}
